<template>
  <el-table-column
    prop="name"
    sortable="custom"
    label="Név"
    show-overflow-tooltip
    fixed
    min-width="250"
  >
    <template slot-scope="scope">
      <el-link type="primary" @click="$router.replace('/sales/invoice-books/view/' + scope.row.id)">
        {{ scope.row.name }}
      </el-link>
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'name',
  };
</script>
